<ng-template #radioButtons>
    <div *ngFor="let option of options; first as isFirst"
         class="tw-w-full field-checkbox">

        <div class="tw-flex tw-content-between tw-gap-4 tw-w-[95%] colorHover"
             (click)="onRadioButtonClick(option.value)">
            <label [for]="option.text"
                   [ngClass]="optionsFormControl.value === option.value ? 'selectionValue [&&]!tw-font-bold' : '!tw-font-normal' ">
                {{ option.text }}
            </label>
            <p-radioButton [inputId]="option.text"
                           [value]="option.value"
                           [name]="option.text"
                           [formControl]="abstractToFormControl(optionsFormControl)"
                           class="tw-ml-auto" />
        </div>
        <p-divider *ngIf="isFirst"></p-divider>
    </div>
</ng-template>


<shared-condition [multiSelection]="false"
                  #condition
                  [outsideDropdown]="true"
                  [dropdownTemplate]="radioButtons"></shared-condition>